import React,{ Fragment, Component} from 'react';
import WOW from 'wowjs';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
import Mapview from './../../Element/Mapview';
import PlanSelect from './../../Element/PlanSelect';

import { FLOOR_PLAN_ITEMS } from '../../../data/floorPlans';
import '../FloorPlans.css';
import { sendContactEmail } from '../../../api/emailsender/EmailSender';
import { serializeForm } from '../../../api/emailsender/formSerialize';

//images/

import bgimg from './../../../images/bg-view.png';


class ContactUs1 extends Component{
	state = {
		showCustomizedModal: false,
		selectedPlan: '',
		contactSubmitting: false,
		contactFeedback: '',
		contactError: '',
		modalSubmitting: false,
		modalError: '',
	};

	handleContactFormSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ contactSubmitting: true, contactFeedback: '', contactError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Contact Us — main form';
		const result = await sendContactEmail(formData, 'Star Giga — Contact form');
		this.setState({ contactSubmitting: false });
		if (result.ok) {
			this.setState({ contactFeedback: 'Thank you! We will get back to you soon.' });
			form.reset();
		} else {
			this.setState({ contactError: result.error });
		}
	};

	handleModalPlanSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ modalSubmitting: true, modalError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Contact Us — customized plan modal';
		const result = await sendContactEmail(formData, 'Star Giga — Customized plan request');
		this.setState({ modalSubmitting: false });
		if (result.ok) {
			form.reset();
			this.setState({ showCustomizedModal: false });
			alert('Thank you! We will contact you shortly with your customized plan.');
		} else {
			this.setState({ modalError: result.error });
			alert(result.error);
		}
	};

	componentDidMount(){
		new WOW.WOW().init();

		const search = (this.props.location && this.props.location.search) || '';
		const params = new URLSearchParams(search);
		const siteVisit = params.get('siteVisit');

		if (siteVisit === '1') {
			this.setState({
				showCustomizedModal: true,
				selectedPlan: (FLOOR_PLAN_ITEMS[0] && FLOOR_PLAN_ITEMS[0].name) || '',
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.showCustomizedModal !== prevState.showCustomizedModal) {
			document.body.style.overflow = this.state.showCustomizedModal ? 'hidden' : '';
		}
	}

	componentWillUnmount() {
		document.body.style.overflow = '';
	}
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Contact Us" activeMenu="Contact Us" />
					{/*  Inner Page Banner */}
					<section className="content-inner-1" data-content="">				
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-4 col-md-5 col-sm-12">
									<div className="section-head m-b30">
										<h2 className="title">Do You Have Any Question?</h2>
										<div className="dlab-separator bg-primary"></div>
										<h5 className="title-small">CONTACT US</h5>
									</div>
									<ul className="contact-question">
										<li>
											<i className="fa fa-map-marker"></i>
											<h4 className="title">Address</h4>
											<p>Ajman, United Arab Emirates</p>
										</li>
										<li>
											<i className="fa fa-envelope-o"></i>
											<h4 className="title">Email</h4>
											<p>info@stargiga.com</p>
										</li>
										<li>
											<i className="fa fa-phone"></i>
											<h4 className="title">Phone</h4>
											<p>+971-67-412-344</p>
										</li>
										
									</ul>
								</div>
								<div className="col-lg-8 col-md-7 col-sm-12 m-b30">
									<form className="contact-box dzForm p-a30 border-1" onSubmit={this.handleContactFormSubmit}>
										<h3 className="title-box">Write us a few words about your project and we’ll prepare a proposal for you within 24 hours</h3>
										<div className="dzFormMsg m-b20">
											{this.state.contactFeedback && (
												<div className="alert alert-success">{this.state.contactFeedback}</div>
											)}
											{this.state.contactError && (
												<div className="alert alert-danger">{this.state.contactError}</div>
											)}
										</div>
										<div className="row">
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="firstName" type="text" required="" className="form-control" placeholder="First Name" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="lastName" type="text" required="" className="form-control" placeholder="Last Name" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group">
														<input name="phone" type="text" required="" className="form-control" placeholder="Phone" />
													</div>
												</div>
											</div>
											<div className="col-lg-6 col-md-6">
												<div className="form-group">
													<div className="input-group"> 
														<input name="email" type="email" className="form-control" required="" placeholder="Your Email Id" />
													</div>
												</div>
											</div>
											<div className="col-lg-12 col-md-12">
												<div className="form-group">
													<div className="input-group">
														<textarea name="message" rows="4" className="form-control" required="" placeholder="Tell us about your project or idea"></textarea>
													</div>
												</div>
											</div>
											<div className="col-lg-12">
												<div className="form-group form-recaptcha">
													<div className="input-group">
														<div className="g-recaptcha" data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN" data-callback="verifyRecaptchaCallback" data-expired-callback="expiredRecaptchaCallback"></div>
														<input className="form-control d-none" style={{display:"none"}} data-recaptcha="true" data-error="Please complete the Captcha" />
													</div>
												</div>
											</div>
											<div className="col-lg-12 col-md-12">
												<button name="submit" type="submit" value="Submit" className="btn btn-primary btn-lg" disabled={this.state.contactSubmitting}>
													{this.state.contactSubmitting ? 'Sending…' : 'Submit'}
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</section>
					{/* <div>				
						<img src={bgimg} className="bg-view" alt=""/>
					</div>
					<Mapview /> */}
				</div>

				{/* Customized Plan Modal (opened from "Book a Site Visit") */}
				{this.state.showCustomizedModal && (
					<div
						className="fp-modal-overlay"
						onClick={() => this.setState({ showCustomizedModal: false })}
					>
						<div className="fp-modal" onClick={(e) => e.stopPropagation()}>
							<button
								type="button"
								className="fp-modal-close"
								aria-label="Close"
								onClick={() => this.setState({ showCustomizedModal: false })}
							>
								×
							</button>
							<div className="fp-modal-header">
								<h3>Request Customized Plan</h3>
								<p>Tell us your requirements and we&apos;ll create a tailored plan for you</p>
							</div>

							<form className="fp-modal-form" onSubmit={this.handleModalPlanSubmit}>
								<input type="hidden" name="plan" value={this.state.selectedPlan} />

								<div className="fp-form-row fp-form-row-2">
									<div className="fp-form-group">
										<label htmlFor="fp-cu-name">Full Name *</label>
										<input id="fp-cu-name" name="name" type="text" required placeholder="Name" />
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-cu-phone">Phone *</label>
										<input id="fp-cu-phone" name="phone" type="tel" required placeholder="+971 67 412 344" />
									</div>
								</div>

								<div className="fp-form-group">
									<label htmlFor="fp-cu-plan-interest">Plan of Interest</label>
									<PlanSelect
										id="fp-cu-plan-interest"
										name="planInterest"
										plans={FLOOR_PLAN_ITEMS}
										defaultValue={this.state.selectedPlan || (FLOOR_PLAN_ITEMS[0] && FLOOR_PLAN_ITEMS[0].name)}
									/>
								</div>

								<div className="fp-form-row fp-form-row-2">
									<div className="fp-form-group">
										<label htmlFor="fp-cu-installments">Installments</label>
										<PlanSelect
											id="fp-cu-installments"
											name="installments"
											plans={[
												{ name: '1 Year' },
												{ name: '2 Years' },
												{ name: '3 Years' },
												{ name: '4 Years' },
												{ name: '5 Years' },
											]}
											defaultValue="1 Year"
										/>
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-cu-advance-payment">Advance Payment</label>
										<input
											id="fp-cu-advance-payment"
											name="advancePayment"
											type="text"
											placeholder="e.g. AED 50,000"
										/>
									</div>
								</div>

								<div className="fp-form-group">
									<label htmlFor="fp-cu-requirements">Your Requirements *</label>
									<textarea
										id="fp-cu-requirements"
										name="requirements"
										rows="4"
										required
										placeholder="Describe your customization needs: room modifications, layout preferences, additional features, etc."
									/>
								</div>

								{this.state.modalError && (
									<p className="text-danger small mb-2">{this.state.modalError}</p>
								)}
								<button type="submit" className="fp-modal-submit" disabled={this.state.modalSubmitting}>
									{this.state.modalSubmitting ? 'Sending…' : 'Submit Request'}
								</button>
							</form>
						</div>
					</div>
				)}

				<FooterPremium />
			</Fragment>
		)	
	}
}
export default ContactUs1;